export default {"src":"/_next/static/media/plus-product.459aaabe.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};